/* ==========================================================================
   Emperielle Atelier — theme script (no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var T = window.EmpTheme || { routes: {}, strings: {}, delivery: {} };
  var R = T.routes || {};
  var S = T.strings || {};
  var root = (R.root || '/').replace(/\/$/, '');

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var el = $('[data-emp-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2400);
  }

  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.classList.add('emp-scroll-lock'); }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('emp-scroll-lock'); }

  function focusFirst(container) {
    var f = container.querySelector('input:not([type="hidden"]):not([disabled]), button:not([disabled]), a[href], select, textarea, [tabindex]:not([tabindex="-1"])');
    (f || container).focus({ preventScroll: true });
  }

  /* ---------- Drawers ---------- */
  var lastTrigger = null;
  var Drawers = {
    open: function (id, trigger) {
      var drawer = document.getElementById(id);
      if (!drawer || drawer.classList.contains('is-open')) return;
      Drawers.closeAll();
      lastTrigger = trigger || document.activeElement;
      drawer.classList.add('is-open');
      var overlay = $('[data-drawer-overlay="' + id + '"]');
      if (overlay) overlay.classList.add('is-open');
      $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockScroll();
      setTimeout(function () { focusFirst(drawer); }, 60);
    },
    close: function (drawer) {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      var overlay = $('[data-drawer-overlay="' + drawer.id + '"]');
      if (overlay) overlay.classList.remove('is-open');
      $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockScroll();
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    },
    closeAll: function () { $$('[data-drawer].is-open').forEach(Drawers.close); }
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); Drawers.open(openBtn.getAttribute('data-drawer-open'), openBtn); return; }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { Drawers.close(closeBtn.closest('[data-drawer]')); return; }
    var overlay = e.target.closest('[data-drawer-overlay]');
    if (overlay) { Drawers.close(document.getElementById(overlay.getAttribute('data-drawer-overlay'))); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Drawers.closeAll();
    Search.close();
    Modals.closeAll();
    Lightbox.close();
    $$('[data-mega-item].is-open').forEach(function (i) { i.classList.remove('is-open'); });
  });

  /* ---------- Announcement bar ---------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach(function (bar) {
      var items = $$('[data-announcement-item]', bar);
      if (items.length < 2) return;
      var i = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      var timer = setInterval(next, interval);
      function next() {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', function () { clearInterval(timer); timer = setInterval(next, interval); });
    });
  }

  /* ---------- Header & mega menu ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    $$('[data-mega-item]').forEach(function (item) {
      var link = item.querySelector('.emp-nav__link');
      var openT, closeT;
      function open() { clearTimeout(closeT); openT = setTimeout(function () { $$('[data-mega-item].is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }, 90); }
      function close() { clearTimeout(openT); closeT = setTimeout(function () { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 160); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); var first = item.querySelector('.emp-mega a'); if (first) first.focus(); }
      });
      link.addEventListener('touchend', function (e) {
        if (!item.classList.contains('is-open')) { e.preventDefault(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
      });
    });

    $$('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (sub) sub.hidden = open;
      });
    });
  }

  /* ---------- Footer accordions (mobile) ---------- */
  function initFooter() {
    /* Footer menus are always open; nothing to collapse. */
  }

  /* ---------- Search drawer ---------- */
  var Search = {
    el: null, overlay: null, input: null, results: null, controller: null,
    init: function () {
      this.el = $('[data-search-drawer]');
      this.overlay = $('[data-search-overlay]');
      if (!this.el) return;
      this.input = $('[data-search-input]', this.el);
      this.results = $('[data-search-results]', this.el);
      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-search-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-search-close]') || e.target === self.overlay) self.close();
      });
      this.input.addEventListener('input', debounce(function () { self.query(self.input.value.trim()); }, 260));
    },
    open: function () {
      if (!this.el || this.el.classList.contains('is-open')) return;
      Drawers.closeAll();
      this.el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      lockScroll();
      var input = this.input;
      setTimeout(function () { input.focus(); }, 80);
    },
    close: function () {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      unlockScroll();
    },
    query: function (q) {
      var self = this;
      if (!q) { this.results.innerHTML = ''; return; }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      var url = (R.predictiveSearch || '/search/suggest') + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page,article,query&resources[limit]=8&resources[limit_scope]=each&resources[options][prefix]=last';
      fetch(url, this.controller ? { signal: this.controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var section = doc.querySelector('.shopify-section') || doc.body;
          self.results.innerHTML = section.innerHTML;
        })
        .catch(function () {});
    }
  };

  /* ---------- Cart ---------- */
  var Cart = {
    sectionId: 'cart-drawer',
    hasDrawer: function () { return !!document.getElementById('CartDrawer'); },
    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
      $$('[data-cart-count-text]').forEach(function (el) { el.textContent = count; });
    },
    renderDrawer: function (html) {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer || !html) return;
      var doc = parseHTML(html);
      var fresh = doc.getElementById('CartDrawer');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    },
    refresh: function () {
      return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.updateCount(cart.item_count); return cart; });
    },
    afterAdd: function (data) {
      if (data && data.sections && data.sections[Cart.sectionId]) Cart.renderDrawer(data.sections[Cart.sectionId]);
      return Cart.refresh().then(function () {
        if (T.cartType === 'drawer' && Cart.hasDrawer()) {
          Drawers.open('CartDrawer');
        } else {
          window.location.href = R.cart || '/cart';
        }
      });
    },
    add: function (formData) {
      if (Cart.hasDrawer()) {
        formData.append('sections', Cart.sectionId);
        formData.append('sections_url', window.location.pathname);
      }
      return fetch(root + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw new Error(j.description || j.message || S.cartError); } return j; }); });
    },
    change: function (line, quantity) {
      var drawer = document.getElementById('CartDrawer');
      var lineEl = drawer ? drawer.querySelector('[data-cart-line][data-index="' + line + '"]') : null;
      if (lineEl) lineEl.classList.add('is-loading');
      return fetch(root + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: Cart.hasDrawer() ? [Cart.sectionId] : [], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || S.cartError); return j; }); })
        .then(function (cart) {
          if (cart.sections && cart.sections[Cart.sectionId]) Cart.renderDrawer(cart.sections[Cart.sectionId]);
          Cart.updateCount(cart.item_count);
          if ($('[data-cart-page]')) window.location.reload();
        })
        .catch(function (err) {
          if (lineEl) lineEl.classList.remove('is-loading');
          var box = $('[data-cart-error]');
          if (box) { box.textContent = err.message; box.hidden = false; } else { toast(err.message); }
        });
    },
    saveNote: debounce(function (note) {
      fetch(root + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note }) });
    }, 400),
    init: function () {
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && Cart.hasDrawer() && T.cartType === 'drawer') { e.preventDefault(); Drawers.open('CartDrawer', opener); return; }
        var qtyBtn = e.target.closest('[data-line-qty]');
        if (qtyBtn) {
          var line = qtyBtn.closest('[data-cart-line]');
          if (line) Cart.change(parseInt(line.getAttribute('data-index'), 10), Math.max(0, parseInt(qtyBtn.getAttribute('data-line-qty'), 10) || 0));
        }
      });
      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-line-input]');
        if (input) {
          var line = input.closest('[data-cart-line]');
          Cart.change(parseInt(line.getAttribute('data-index'), 10), Math.max(0, parseInt(input.value, 10) || 0));
        }
      });
      document.addEventListener('input', function (e) {
        if (e.target.matches('[data-cart-note]')) Cart.saveNote(e.target.value);
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
    }
  };

  /* ---------- Product form ---------- */
  function ProductForm(wrap) {
    this.wrap = wrap;
    this.root = wrap.closest('[data-product-root]') || document;
    this.form = wrap.querySelector('form');
    this.idInput = wrap.querySelector('[data-variant-id]');
    this.button = wrap.querySelector('[data-add-button]');
    this.label = wrap.querySelector('[data-add-label]');
    this.priceTag = wrap.querySelector('[data-add-price]');
    this.error = wrap.querySelector('[data-form-error]');
    this.dynamic = wrap.querySelector('[data-dynamic-checkout]');
    this.sizeIndex = parseInt(wrap.getAttribute('data-size-index'), 10);
    this.isMain = !!wrap.closest('[data-main-form]');
    var json = wrap.querySelector('[data-product-json]');
    this.product = json ? JSON.parse(json.textContent) : { variants: [], options: [] };
    this.fieldsets = $$('.emp-option', wrap);
    this.bind();
    this.updateAvailability();
    if (this.isMain) {
      this.initSticky();
      var stickyLabel = this.root.querySelector('[data-sticky-add]');
      if (stickyLabel && this.label) stickyLabel.textContent = this.label.textContent.trim();
    }
  }
  ProductForm.prototype.selected = function () {
    return this.fieldsets.map(function (fs) {
      var checked = fs.querySelector('[data-option-value]:checked');
      return checked ? checked.value : null;
    });
  };
  ProductForm.prototype.findVariant = function (sel) {
    if (sel.some(function (v) { return v === null; })) return null;
    return this.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    }) || false;
  };
  ProductForm.prototype.updateAvailability = function () {
    var sel = this.selected();
    var variants = this.product.variants;
    this.fieldsets.forEach(function (fs, idx) {
      $$('[data-option-value]', fs).forEach(function (input) {
        var ok = variants.some(function (v) {
          if (!v.available || v.options[idx] !== input.value) return false;
          return v.options.every(function (o, j) { return j === idx || sel[j] === null || o === sel[j]; });
        });
        input.classList.toggle('is-unavailable', !ok);
      });
    });
  };
  ProductForm.prototype.setButton = function (state) {
    var b = this.button;
    if (!b) return;
    b.disabled = false;
    if (state === 'select') { this.label.textContent = S.selectSize; }
    else if (state === 'soldout') { this.label.textContent = S.soldOut; b.disabled = true; }
    else if (state === 'unavailable') { this.label.textContent = S.unavailable; b.disabled = true; }
    else { this.label.textContent = S.addToCart; }
    if (this.priceTag) this.priceTag.hidden = state !== 'add';
    var sticky = this.root.querySelector('[data-sticky-add]');
    if (sticky && this.isMain) { sticky.textContent = this.label.textContent; sticky.disabled = b.disabled; }
  };
  ProductForm.prototype.onChange = function (changedIndex) {
    var sel = this.selected();
    this.fieldsets.forEach(function (fs, i) {
      var out = fs.querySelector('[data-option-selected]');
      if (out) out.textContent = sel[i] || '';
    });
    this.updateAvailability();
    if (this.error) this.error.hidden = true;
    var variant = this.findVariant(sel);
    if (variant === null) {
      this.idInput.value = '';
      this.setButton('select');
      if (this.dynamic) this.dynamic.hidden = true;
      return;
    }
    if (!variant) {
      this.idInput.value = '';
      this.setButton('unavailable');
      if (this.dynamic) this.dynamic.hidden = true;
      return;
    }
    this.idInput.value = variant.id;
    this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.updatePrice(variant);
    this.setButton(variant.available ? 'add' : 'soldout');
    if (this.dynamic) this.dynamic.hidden = !variant.available;
    var changedName = (this.product.options[changedIndex] || '').toLowerCase();
    if (!/size|taglia|taille/.test(changedName)) this.updateMedia(variant);
    if (this.isMain && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };
  ProductForm.prototype.updatePrice = function (variant) {
    var priceBox = this.root.querySelector('[data-product-price] .emp-price');
    if (priceBox) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceBox.innerHTML = '<span class="emp-price__sale" data-price>' + formatMoney(variant.price) + '</span><s class="emp-price__compare" data-compare-price>' + formatMoney(variant.compare_at_price) + '</s>';
      } else {
        priceBox.innerHTML = '<span data-price>' + formatMoney(variant.price) + '</span>';
      }
    }
    var save = this.root.querySelector('[data-save-badge]');
    if (save) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        save.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% off';
        save.hidden = false;
      } else { save.hidden = true; }
    }
    if (this.priceTag) this.priceTag.textContent = formatMoney(variant.price);
    var sticky = this.root.querySelector('[data-sticky-price]');
    if (sticky && this.isMain) sticky.textContent = formatMoney(variant.price);
  };
  ProductForm.prototype.updateMedia = function (variant) {
    if (!variant.featured_media) return;
    var id = String(variant.featured_media.id);
    var list = this.root.querySelector('[data-gallery-list]');
    if (list) {
      var item = list.querySelector('[data-media-id="' + id + '"]');
      if (item && item !== list.firstElementChild) {
        list.insertBefore(item, list.firstElementChild);
        list.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (item) {
        list.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }
    var quickImg = this.root.querySelector('[data-quick-image] img');
    if (quickImg && variant.featured_media.preview_image) {
      var src = variant.featured_media.preview_image.src;
      quickImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      quickImg.removeAttribute('srcset');
    }
  };
  ProductForm.prototype.showError = function (msg, focusSize) {
    if (this.error) { this.error.textContent = msg; this.error.hidden = false; }
    if (focusSize) {
      var fs = this.fieldsets.find(function (f) { return !f.querySelector(':checked'); }) || this.fieldsets[this.sizeIndex];
      if (fs) {
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = fs.querySelector('[data-option-value]');
        if (first) first.focus({ preventScroll: true });
      }
    }
  };
  ProductForm.prototype.bind = function () {
    var self = this;
    this.fieldsets.forEach(function (fs, idx) {
      fs.addEventListener('change', function () { self.onChange(idx); });
    });
    var qty = this.wrap.querySelector('[data-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      $$('[data-qty-step]', qty).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
          input.value = Math.max(1, v);
        });
      });
    }
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!self.idInput.value) {
        var sel = self.selected();
        self.showError(sel.some(function (v) { return v === null; }) ? (S.chooseSize || S.selectSize) : S.unavailable, true);
        return;
      }
      var btn = self.button;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var original = self.label.textContent;
      self.label.textContent = S.adding;
      Cart.add(new FormData(self.form))
        .then(function (data) {
          var quick = self.wrap.closest('#QuickAddDrawer');
          if (quick) Drawers.close(quick);
          return Cart.afterAdd(data);
        })
        .catch(function (err) { self.showError(err.message || S.cartError, false); })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          self.label.textContent = original;
        });
    });
  };
  ProductForm.prototype.initSticky = function () {
    var bar = this.root.querySelector('[data-sticky-atc]');
    var btn = this.button;
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var stickyBtn = bar.querySelector('[data-sticky-add]');
    var self = this;
    var footer = document.querySelector('.emp-footer');
    var mainVisible = true, footerVisible = false;
    function update() {
      var show = !mainVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) { mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; update(); }).observe(btn);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
    stickyBtn.addEventListener('click', function () {
      if (!self.idInput.value) { self.showError(S.chooseSize || S.selectSize, true); return; }
      self.form.requestSubmit ? self.form.requestSubmit() : self.button.click();
    });
  };

  function initProductForms(ctx) {
    $$('[data-product-form]', ctx).forEach(function (wrap) {
      if (wrap._empForm) return;
      wrap._empForm = new ProductForm(wrap);
    });
  }

  /* ---------- Quick add ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var direct = e.target.closest('[data-quick-add-direct]');
      if (direct) {
        e.preventDefault();
        var fd = new FormData();
        fd.append('id', direct.getAttribute('data-quick-add-direct'));
        fd.append('quantity', '1');
        direct.disabled = true;
        Cart.add(fd).then(Cart.afterAdd).catch(function (err) { toast(err.message); }).then(function () { direct.disabled = false; });
        return;
      }
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var body = $('[data-quick-add-body]');
      if (!body) { window.location.href = btn.getAttribute('data-quick-add'); return; }
      body.innerHTML = '<div class="emp-quick__loading"><span class="emp-spinner"></span></div>';
      Drawers.open('QuickAddDrawer', btn);
      var url = btn.getAttribute('data-quick-add');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-add')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var content = doc.querySelector('.emp-quick__body');
          if (!content) { window.location.href = url; return; }
          body.innerHTML = '';
          body.appendChild(document.importNode(content, true));
          initProductForms(body);
          if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
          focusFirst(body);
        })
        .catch(function () { window.location.href = url; });
    });
  }

  /* ---------- Gallery & lightbox ---------- */
  var Lightbox = {
    el: null,
    open: function (mediaId) {
      this.el = $('[data-lightbox]');
      if (!this.el) return;
      this.el.classList.add('is-open');
      lockScroll();
      var target = mediaId ? this.el.querySelector('[data-lightbox-media="' + mediaId + '"]') : null;
      var el = this.el;
      setTimeout(function () {
        if (target) el.scrollTop = target.offsetTop - 8;
        var close = el.querySelector('[data-lightbox-close]');
        if (close) close.focus({ preventScroll: true });
      }, 30);
    },
    close: function () {
      var el = $('[data-lightbox].is-open');
      if (!el) return;
      el.classList.remove('is-open');
      unlockScroll();
    }
  };
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var list = gallery.querySelector('[data-gallery-list]');
      var counter = gallery.querySelector('[data-gallery-counter]');
      var bars = $$('[data-gallery-progress] span', gallery);
      if (!list || (!counter && !bars.length)) return;
      var total = list.children.length;
      list.addEventListener('scroll', debounce(function () {
        var idx = Math.min(Math.round(list.scrollLeft / Math.max(1, list.clientWidth)), total - 1);
        if (counter) counter.textContent = (idx + 1) + ' / ' + total;
        bars.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      }, 40), { passive: true });
    });
    document.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-zoom]');
      if (zoom) {
        var li = zoom.closest('[data-media-id]');
        Lightbox.open(li ? li.getAttribute('data-media-id') : null);
        return;
      }
      if (e.target.closest('[data-lightbox-close]')) Lightbox.close();
    });
  }

  /* ---------- Modals ---------- */
  var Modals = {
    open: function (modal) {
      if (!modal) return;
      modal.classList.add('is-open');
      lockScroll();
      var close = modal.querySelector('.emp-modal__close');
      setTimeout(function () { if (close) close.focus({ preventScroll: true }); }, 40);
    },
    close: function (modal) {
      if (!modal || !modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      unlockScroll();
    },
    closeAll: function () { $$('.emp-modal.is-open').forEach(Modals.close); }
  };
  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-modal-open]');
      if (opener) { e.preventDefault(); Modals.open(document.getElementById(opener.getAttribute('data-modal-open'))); return; }
      var closer = e.target.closest('[data-modal-close]');
      if (closer) { Modals.close(closer.closest('.emp-modal')); return; }
      var copy = e.target.closest('[data-copy]');
      if (copy) {
        var text = copy.getAttribute('data-copy');
        var done = function () { toast((S.copied || 'Copied') + ': ' + text); };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(done, done); }
        else {
          var t = document.createElement('textarea'); t.value = text; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(t); done();
        }
      }
    });
    var welcome = $$('[data-welcome-modal]');
    if (welcome.length) {
      welcome.slice(1).forEach(function (m) { m.remove(); });
      document.body.appendChild(welcome[0]);
      setTimeout(function () { Modals.open(welcome[0]); }, 300);
    }
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    var blocks = $$('[data-recommendations]');
    if (!blocks.length) return;
    var load = function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el._loaded) return;
      el._loaded = true;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = parseHTML(html);
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px 600px 0px' });
      blocks.forEach(function (b) { io.observe(b); });
    } else { blocks.forEach(load); }
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery() {
    var d = T.delivery || {};
    if (!d.enabled) return;
    $$('[data-delivery-estimate]').forEach(function (el) {
      var out = el.querySelector('[data-delivery-range]');
      if (!out) return;
      var min = new Date(); min.setDate(min.getDate() + (parseInt(d.minDays, 10) || 12));
      var max = new Date(); max.setDate(max.getDate() + (parseInt(d.maxDays, 10) || 21));
      var fmt = { month: 'short', day: 'numeric' };
      var loc = document.documentElement.lang || undefined;
      out.textContent = min.toLocaleDateString(loc, fmt) + ' – ' + max.toLocaleDateString(loc, fmt);
      el.hidden = false;
    });
  }

  /* ---------- Collection filters & sort ---------- */
  function initFacets() {
    $$('[data-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
    $$('[data-facets-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    });
  }

  /* ---------- Account pages ---------- */
  function initAccount() {
    var login = $('[data-login-panel]');
    var recover = $('[data-recover-panel]');
    if (login && recover) {
      var show = function (r) { recover.hidden = !r; login.hidden = r; };
      if (window.location.hash === '#recover' || recover.querySelector('[data-recover-success]')) show(true);
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-show-recover]')) { e.preventDefault(); show(true); }
        if (e.target.closest('[data-hide-recover]')) { e.preventDefault(); show(false); }
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-address-toggle]');
      if (!t) return;
      var form = $('[data-address-form="' + t.getAttribute('data-address-toggle') + '"]');
      if (!form) return;
      form.hidden = !form.hidden;
      $$('[data-address-toggle="' + t.getAttribute('data-address-toggle') + '"]').forEach(function (b) { b.setAttribute('aria-expanded', form.hidden ? 'false' : 'true'); });
    });
    $$('[data-address-delete]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.confirm(form.getAttribute('data-confirm'))) e.preventDefault();
      });
    });
  }

  /* ---------- Theme editor support ---------- */
  function initEditor() {
    if (!window.Shopify || !window.Shopify.designMode) return;
    document.addEventListener('shopify:section:load', function (e) {
      initProductForms(e.target);
      initAnnouncements();
      initRecommendations();
      initDelivery();
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initAnnouncements();
    initHeader();
    initFooter();
    Search.init();
    Cart.init();
    initProductForms(document);
    initQuickAdd();
    initGallery();
    initModals();
    initRecommendations();
    initDelivery();
    initFacets();
    initAccount();
    initEditor();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
